import React from "react";
import View from "../../../components/Hijama/Quiz/View/View"
const ViewQuiz = () => {
  return <div><View/></div>;
};

export default ViewQuiz;
